<template>
  <div
  id="app"
  class="container1"
  >
    <div id="main" class="row w-100 " :class="{'p-state-page-admin':checkDisabledProvinceCity}">
        <Sidebar></Sidebar>
        <router-view />
    </div>

    <v-message />

</div>
</template>
<script>
import Sidebar from './components/includes/Sidebar.vue'

export default {
  name: "app",
  components: {
    Sidebar,
  },

  data() {
    return {
      list                      : [],
      checkDisabledProvinceCity : false,
    }
  },

  watch: {

  },

  mounted() {
    if (this.$store.state.statePageAdminAgent == 'Agent') {
      this.checkDisabledProvinceCity = true;
    }
    else {
      this.checkDisabledProvinceCity = false;
    }
  },

  methods: {

  }

}



</script>


<style lang="scss">

</style>
